import { Helmet } from 'react-helmet-async';
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Activity } from "lucide-react";
import { Link } from "react-router-dom";
const GutHealth = () => {
  return <>
      <Helmet>
        <title>Gut Health Services | Functional Foodie</title>
        <meta name="description" content="Specialized gut health services in Johannesburg. Expert treatment for IBS, IBD, heartburn, reflux, and other digestive issues. Consult with Functional Foodie today." />
      </Helmet>
      <section id="gut-health" className="py-16">
        <div className="container mx-auto px-4">
          <Card className="border-none shadow-lg hover:shadow-xl transition-shadow duration-300 bg-[#fedd7d]/20">
            <CardHeader className="flex flex-row items-center gap-4">
              <div className="p-4 rounded-full bg-[#fedd7d]/50">
                <Activity className="w-8 h-8 text-[#85a3a6]" />
              </div>
              <CardTitle className="text-xl font-semibold text-primary">
                Gut Health
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="space-y-6">
                
                
                <h3 className="text-lg font-semibold text-primary mt-8">Our Gut Health Solutions</h3>
                <p className="text-gray-600 leading-relaxed">Gut health is crucial for overall wellbeing. Our dietitians have specialised knowledge in digestive disorders and provide evidence-based dietary interventions to manage symptoms and improve quality of life.</p>
                
                <h3 className="text-lg font-semibold text-primary">Conditions We Treat</h3>
                <ul className="list-disc pl-6 space-y-2 text-gray-600">
                  <li>Irritable Bowel Syndrome (IBS)</li>
                  <li>Inflammatory Bowel Disease (Crohn's and Ulcerative Colitis)</li>
                  <li>GERD, heartburn and reflux</li>
                  <li>Gastritis and stomach discomfort</li>
                  <li>Diverticulosis</li>
                  <li>Chronic constipation</li>
                </ul>
                
                <h3 className="text-lg font-semibold text-primary">Our Approach</h3>
                <p className="text-gray-600 leading-relaxed">
                  We use a combination of dietary strategies, including the low FODMAP diet when appropriate, elimination diets, and targeted supplements to identify triggers and manage symptoms effectively.
                </p>
                
                <div className="mt-8 flex justify-center">
                  <Link to="/booking">
                    <Button size="lg" className="bg-primary hover:bg-primary-light text-white px-8">
                      Book a Consultation
                    </Button>
                  </Link>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>
    </>;
};
export default GutHealth;